
import React, { useEffect, useState } from 'react';

import ExternalConfiguration from '../../external-configuration';

// import './Wrapper-Bradmax-s73.css';

const Constants = {
  PlayerId: 'Bradmax-player-s73',
  PlayerScritpSrc: `${ExternalConfiguration.SelfHostedExternalSrcPaths.Bradmax}/player.js`,
  S73ScriptSrc: `${ExternalConfiguration.SelfHostedExternalSrcPaths.s73}/s73-sdk-hlsjs.js`,
  S73SdkConfig: {
    apiKey: ExternalConfiguration.Credentials.S73ApiKey,
    // contentSteeringEndpoint: '<YOUR_CONTENT_STEERING_RESOURCE>', // optional
    // channelId: '<CHANNEL_ID>' // optional
  },
};

const Globals = {
  playerScript: null,
  s73Script: null,
  s73Wrapper: null,
  player: null,
};

const onLoadS73 = (event, props) => {
  console.log( 'props: ', props);
  const player_element = document.getElementById( Constants.PlayerId);
  window.bradmax.player.create( player_element, {
    dataProvider: {
      // skin: { theme: 'zebra' },
      source: [
        // { url: ExternalConfiguration.DefaultErrorVideo },
        { url: props.contentData.singleMedia.file },
      ],
      splashImages: [
        { url: props.contentData.singleMedia.image },
      ],
    },
    system73: {
      apiKey: Constants.S73SdkConfig.apiKey,
    },
  });
};

const onLoadPlayer = (event, props) => {
  Globals.s73Script = document.createElement( 'script');
  Globals.s73Script.src = Constants.S73ScriptSrc;
  Globals.s73Script.async = true;
  Globals.s73Script.onload = event => onLoadS73( event, props);
  document.head.append( Globals.s73Script );
};

export default function Wrapper_Bradmax_player( props) {
  const { width, height } = props.bradmax_playerConfiguration?.customProps ?? {};
  const { PlayerId, PlayerScritpSrc } = Constants;
  const { player } = Globals;
// console.log( 'render: ', width, height, player, player?.getWidth, player?.getHeight, player?.resize, props);
  if( player && (player.getWidth() !== width || player.getHeight() !== height)) player.resize( width, height);

  useEffect( () => {
    Globals.playerScript = document.createElement( 'script');
    Globals.playerScript.src = PlayerScritpSrc;
    Globals.playerScript.async = true;
    Globals.playerScript.onload = event => onLoadPlayer( event, props);
    document.head.append( Globals.playerScript );
  }, []);

  // console.log( 'components::Wrapper-Bradmax-player::render - props: ', props);    // DEVELOP
  return (
    <div className='wrapper-custom-3-s73-player-container' style={{ width: window.innerWidth, height: window.innerHeight }}>
      <div id={PlayerId} style={{ width: '100%', height: '100% '}}/>
    </div>
  );
}
